export default "__VITE_ASSET__bb5f4910__"